import React from "react";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import styles from "./sliderTitle.module.scss";

function SliderTitle({ className }) {
  const { t } = useTranslation(["common"]);

  return (
    <div className={`${className} ${styles.mainContainer}`}>
      <Typography gutterBottom variant="h3" color="text.title" component="div">
        {t("Savings Calculator")}
      </Typography>
      <Typography variant="body" color="text.secondary">
        {t("Use the sliders to customize the data to your situation")}
      </Typography>
    </div>
  );
}

export default SliderTitle;
